module.exports = __webpack_public_path__ + "img/Certificate_6.a24344e6.jpg";